import React from "react";
import './style.scss';
import {IEvent} from "../../redux/reducers/contents/sample-data/events";
import NotificationItem from "./notification-item";
import {useDispatch} from "react-redux";
import {clearAllEvents} from "../../redux/reducers/contents";

interface NotificationProps {
    isActive: boolean
    events: IEvent[],
}

const Notification: React.FC<NotificationProps> = (props) => {

    const dispatch = useDispatch();


    return (
        <div
            className={'notification-list p-2 d-flex flex-column bg-light align-items-center' + (props.isActive ? ' active' : '')}>
            {
                props.events.length > 0 ?
                    <button className='btn clear-btn text-black'
                            onClick={() => dispatch(clearAllEvents())}
                    >
                        Clear All
                    </button> : ''
            }
            {
                props.events.map((e) => {
                        const id = Object.keys(e)[0];
                        return <NotificationItem
                            key={id}
                            id={id}
                            objectID={e[id].objectID}
                            type={e[id].type}
                            time={e[id].time}
                        />
                    }
                )
            }
        </div>
    )
}

export default Notification;
